import { useMemo } from 'react'

import { ISchema } from '@formily/json-schema'

import { SchemaItem } from '../interface'
import { randomNameFactory } from '../utils/randomNameFactory'

const resolveProperties = (items: SchemaItem[]) => {
  const getRandomName = randomNameFactory()

  const properties: Record<string, ISchema> = {}

  for (const { name, ...fieldProps } of items) {
    const key = name || getRandomName()
    properties[key] = fieldProps
  }

  return properties
}

const resolveSchema = (items: SchemaItem[]) => {
  const schema: ISchema = {
    type: 'object',
    properties: resolveProperties(items)
  }

  return schema
}

/**
 * 把自定义的 schema 转成符合 formily 标准的 schema
 *
 * @param items 表单配置项
 * @returns formily schema
 */
export const useTransformSchema = (items: SchemaItem[]) => {
  return useMemo(() => resolveSchema(items), [items])
}
